var app = angular.module('app');
app.controller('appCtrl', ["$scope", "$location", "$firebaseObject", "$firebaseAuth", "$firebaseArray", function ($scope, $location, $firebaseObject, $firebaseAuth, $firebaseArray) {
    $scope.title = 'Expansions';
    $scope.authObj = $firebaseAuth();
    $scope.authObj.$onAuthStateChanged(function (firebaseUser) {
        if (firebaseUser) {
            firebaseUser.getIdTokenResult().then(function(idTokenResult) {
                $scope.$apply(function() {
                    $scope.isAuthenticated = true;
                    $scope.isAdmin = !!idTokenResult.claims.admin;
                });
            });
        } else {
            window.location.href = '/login/login';
        }
    }, function (error) {
        console.error("Authentication state error:", error);
    });

    var ref = firebase.database().ref();
    $scope.remoteItems = $firebaseArray(ref.child("expansion"));
    $scope.DB = [];

    $scope.remoteItems.$loaded().then(function () {
        angular.forEach($scope.remoteItems, function (item) {
            var newItem = new Object();
            newItem.$id = item.$id;
            newItem.name = item.name;
            newItem.imageUrl = item.imageUrl;
            $scope.DB.push(newItem);
        });
    });

    $scope.add = function () {
        window.location.href = '/expansion/add';
    };

    $scope.edit = function (value) {
        window.location.href = '/expansion/edit?id=' + value.$id;
    };

    $scope.delete = function (item) {
        if (confirm('Would you like to delete ' + item.name + ' now?')) {
            var record = $scope.remoteItems.$getRecord(item.$id);
            $scope.remoteItems.$remove(record).then(function () {
                var index = $scope.DB.indexOf(item);
                if (index > -1) $scope.DB.splice(index, 1);
            });
        }
    };
}]);